<template>
  <div
    class="w-full bg-white pl-4 py-4 font-medium shadow-sm select-none flex justify-between px-4"
  >
    <div>
      <router-link to="/">
        <font-awesome-icon icon="wind" class="text-xl font-medium text-pastel-green-600"/>
        <h1 v-for="provider in providers" :key="provider.name" class="ml-2 tracking-widest">{{provider.name}} {{provider.description}} </h1>
      </router-link>
    </div>
  </div>
</template>

<script>

import ProvidersService from "@/helpers/apiservices/providers/providers.service";
import Notify from "@/helpers/notify";

export default {
  name: "LHeader",
  data() {
    return {
      providers : []
    };
  },
  mounted() {
    Notify.loadData(null, this.loadInitialData);
  },

  methods: {
    async loadInitialData() {
      this.providers = await ProvidersService.provider();
    }
  }
};
</script>


<style lang="postcss" scoped>
h1 {
  @apply text-lg font-bold inline-block;
}

a {
  text-decoration: none;
  @apply text-pastel-black;
}
</style>
